import { useState } from 'react';
import { Check, X } from 'lucide-react';
import { Modal } from '../../components/Modal';
import { useT } from '../../i18n';

interface GroupNameDialogProps {
  title: string;
  confirmLabel: string;
  initialName: string;
  onCancel: () => void;
  onConfirm: (name: string) => void;
}

/** Modal pro vytvoření/přejmenování skupiny (E6-US4/US5) — text entry se hodí do centrovaného Modalu. */
export function GroupNameDialog({
  title,
  confirmLabel,
  initialName,
  onCancel,
  onConfirm,
}: GroupNameDialogProps) {
  const t = useT();
  const [name, setName] = useState(initialName);
  const trimmed = name.trim();

  return (
    <Modal
      title={title}
      onClose={onCancel}
      actions={
        <>
          <button type="button" onClick={onCancel}>
            <X size={16} />
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="primary"
            disabled={!trimmed}
            onClick={() => onConfirm(trimmed)}
          >
            <Check size={16} />
            {confirmLabel}
          </button>
        </>
      }
    >
      <div className="field">
        <label htmlFor="group-name">{t('canvas.group.nameLabel')}</label>
        <input
          id="group-name"
          value={name}
          autoFocus
          onChange={(event) => setName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && trimmed) onConfirm(trimmed);
          }}
        />
      </div>
    </Modal>
  );
}
